import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Form, Input, Modal } from 'antd';

export const ResendRequestModal = ({ request }) => {
  const { control, handleSubmit } = useForm({ defaultValues: { reason: '' } });
  return (
    <Modal
      title={`ส่งซ้ำ: ${request.target.claimCode}`}
      open
      okText="ส่งคำขอ"
      cancelText="ยกเลิก"
      confirmLoading={request.isPending}
      cancelButtonProps={{ disabled: request.isPending }}
      closable={!request.isPending}
      maskClosable={false}
      onCancel={request.closeRequest}
      onOk={handleSubmit(request.submitRequest)}
    >
      <Controller
        name="reason"
        control={control}
        rules={{
          validate: (value) => !!value.trim() || 'กรุณาระบุเหตุผลส่งซ้ำ',
          maxLength: { value: 250, message: 'ระบุได้ไม่เกิน 250 ตัวอักษร' },
        }}
        render={({ field, fieldState }) => (
          <Form.Item
            label="เหตุผลส่งซ้ำ"
            required
            validateStatus={fieldState.error ? 'error' : undefined}
            help={fieldState.error?.message}
          >
            <Input.TextArea
              {...field}
              rows={4}
              maxLength={250}
              showCount
              disabled={request.isPending}
            />
          </Form.Item>
        )}
      />
    </Modal>
  );
};
